import {
  AfterContentInit,
  ChangeDetectorRef,
  Component, effect,
  inject, input,
  model,
  OnDestroy,
  OnInit, signal,
  ViewChild
} from '@angular/core';
import {APIService, ToastService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {ButtonComponent, ButtonOptions, ModalComponent, ModalOptions, TableComponent} from '@shared/components';
import {HTTPMethods, ModalTypes} from '@core/enums';
import {HttpHeaders} from '@angular/common/http';
import {CurrentIllness} from '@core/classes/tables/current-illness';

@Component({
  selector: 'ncp-problem-diagnosis-status-action',
  imports: [
    ModalComponent,
    ButtonComponent
  ],
  templateUrl: './problem-diagnosis-status-action.component.html',
  styleUrl: './problem-diagnosis-status-action.component.scss',
})
export class ProblemDiagnosisStatusActionComponent implements OnInit, AfterContentInit, OnDestroy {
  protected readonly toastService = inject(ToastService);
  protected readonly apiService = inject(APIService);
  protected readonly patientService = inject(PatientService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('btn') public btn!: ButtonComponent;

  protected data = model<CurrentIllness>();
  protected allData = model<CurrentIllness[]>();
  protected reloadData = model<() => {}>();
  protected index = input<number>();
  protected tbl = model<TableComponent<CurrentIllness>>(new TableComponent());

  protected btnOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'action'
    })
  );
  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.confirm,
    })
  );

  statusEffect = effect(() => {
    this.setConfirm();
  });

  setConfirm = () => {
    if(this.row?.version_id?.toString() !== this.patientService.version!.new?.toString()) {
      this.modOptions().title = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().message = this.row?.status === 1 ? 'confirm_disable' : 'confirm_enable';
      this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
      this.btnOptions().class = '';
      this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().onYes = this.changeStatus;
    } else {
      this.modOptions().title = 'delete_entry';
      this.modOptions().message = 'confirm_delete';
      this.btnOptions().icon = 'bi bi-trash3';
      this.btnOptions().class = 'btn-danger';
      this.btnOptions().tooltip = 'delete_entry';
      this.modOptions().onYes = this.deleteEntry;
    }
  }

  ngOnInit() {
    this.btnOptions().onClick = () => {
      this.setConfirm();
      this.btn.blur();
      this.mod.open();
    };
  }

  ngOnDestroy() {
    this.statusEffect.destroy();
  }

  ngAfterContentInit() {

  }

  get row() {
    return this.data();
  }
  set row(row) {
    this.data.set(row);
  }

  protected changeStatus = () => {
    this.apiService.call({
      path: '/illness',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        status: this.data()?.status === 1 ? 0 : 1,
        onset_date: this.data()?.onset_date,
        coding_id: this.data()?.coding_id,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if(res && res.status && res.status.toString() === '1') {
        let allData = this.allData() as CurrentIllness[];
        allData[this.index()!].status = allData[this.index()!].status === 1 ? 0 : 1;
        this.row = allData[this.index()!];

        this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
        this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';

        (this.tbl() as TableComponent<CurrentIllness>).detectChanges();

        this.mod.close('success');
      }
    });
  }

  protected deleteEntry = () => {
    this.apiService.call({
      path: '/delete-illness',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        onset_date: this.data()?.onset_date,
        coding_id: this.data()?.coding_id,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if (res && res.status && res.status.toString() === '1') {
        let allData = (this.tbl() as TableComponent<CurrentIllness>).tableData;

        (this.tbl() as TableComponent<CurrentIllness>).tableData = allData!.filter(item => {
          return !((item.coding_id?.toString() === this.data()?.coding_id?.toString()) &&
            (item.onset_date?.toString() === this.data()?.onset_date?.toString()) &&
            (item.version_id?.toString() === this.data()?.version_id?.toString()))
        });

        (this.tbl() as TableComponent<CurrentIllness>).reload().detectChanges();
        this.mod.close('success');
      }
    });
  }
}
